import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";

export type CMButtonProps = { label?: string } & ButtonProps;

/**
 *ベースとなるボタン。色、ラベル、サイズを指定できる。
 */
export const CMButton = ({
  label,
  size = "md",
  colorScheme = "teal",
  sx,
  ...rest
}: CMButtonProps) => {
  return (
    <Button colorScheme={colorScheme} size={size} sx={sx} {...rest}>
      {label}
    </Button>
  );
};
